
import { Link } from 'react-router-dom';

export default function Footer() {
  const quickLinks = [
    { name: 'Ana Sayfa', href: '/' },
    { name: 'Hizmetler', href: '/hizmetler' },
    { name: 'Hakkımızda', href: '/hakkimizda' },
    { name: 'İletişim', href: '/iletisim' },
    { name: 'GRI Raporlama', href: '/iletisim' },
    { name: 'TSRS Danışmanlığı', href: '/iletisim' },
    { name: 'Karbon Ayak İzi', href: '/iletisim' },
    { name: 'ESG Danışmanlığı', href: '/iletisim' },
  ];

  const services = [
    'Sürdürülebilirlik Danışmanlığı',
    'GRI Sürdürülebilirlik Raporu',
    'TSRS Sürdürülebilirlik Raporu',
    'CSRD Raporlama',
    'ESG Danışmanlığı',
    'Karbon Ayak İzi',
    'Su Ayak İzi',
    'CBAM/SKDM Danışmanlığı',
    'LCA Yaşam Döngüsü Analizi',
    'EPD Belgesi',
    'Ecovadis Danışmanlığı',
    'SBTi Danışmanlığı'
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1">
            <div className="text-2xl font-bold text-emerald-400 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              ECOVENTRA
            </div>
            <p className="text-gray-300 text-sm mb-6 leading-relaxed">
              Türkiye'nin yenilikçi sürdürülebilirlik danışmanlık şirketi. 
              Start-up ruhuyla modern çözümler sunarak işletmelerin sürdürülebilirlik hedeflerine ulaşmalarına yardımcı oluyoruz.
            </p>
            
            {/* Social Media */}
            <div className="flex space-x-4 mb-6">
              <a 
                href="https://www.linkedin.com/company/ecoventra/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors group"
              >
                <i className="ri-linkedin-fill text-lg text-gray-400 group-hover:text-white"></i>
              </a>
              <a 
                href="https://www.instagram.com/ecoventra/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors group"
              >
                <i className="ri-instagram-fill text-lg text-gray-400 group-hover:text-white"></i>
              </a>
              <a 
                href="https://www.facebook.com/ecoventra/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors group"
              >
                <i className="ri-facebook-fill text-lg text-gray-400 group-hover:text-white"></i>
              </a>
              <a 
                href="https://www.youtube.com/channel/ecoventra" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors group"
              >
                <i className="ri-youtube-fill text-lg text-gray-400 group-hover:text-white"></i>
              </a>
            </div>

            {/* Certifications */}
            <div className="text-xs text-gray-400">
              <div className="mb-2">✓ GRI Sertifikalı Partner</div>
              <div className="mb-2">✓ TÜV Austria Onaylı</div>
              <div>✓ Responsible Program Yetkili</div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-6">Hızlı Erişim</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href} 
                    className="text-gray-300 hover:text-emerald-400 transition-colors text-sm flex items-center group"
                  >
                    <i className="ri-arrow-right-s-line text-xs opacity-0 group-hover:opacity-100 transition-opacity mr-1"></i>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-6">Hizmetlerimiz</h3>
            <ul className="space-y-3">
              {services.slice(0, 8).map((service) => (
                <li key={service}>
                  <Link 
                    to="/iletisim" 
                    className="text-gray-300 text-sm hover:text-emerald-400 transition-colors cursor-pointer group flex items-center"
                  >
                    <i className="ri-arrow-right-s-line text-xs opacity-0 group-hover:opacity-100 transition-opacity mr-1"></i>
                    {service}
                  </Link>
                </li>
              ))}
              <li>
                <Link 
                  to="/hizmetler" 
                  className="text-emerald-400 text-sm font-medium hover:text-emerald-300 transition-colors"
                >
                  Tüm Hizmetler →
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Location */}
          <div>
            <h3 className="text-white font-semibold mb-6">İletişim</h3>
            
            {/* Contact Info */}
            <div className="space-y-4 mb-6">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-emerald-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-white text-sm"></i>
                </div>
                <div>
                  <a href="tel:+905434373049" className="text-gray-300 text-sm hover:text-emerald-400 transition-colors">
                    +90 543 437 30 49
                  </a>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-emerald-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-white text-sm"></i>
                </div>
                <div>
                  <a href="tel:+905326230183" className="text-gray-300 text-sm hover:text-emerald-400 transition-colors">
                    +90 532 623 01 83
                  </a>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-emerald-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-white text-sm"></i>
                </div>
                <div>
                  <a href="mailto:info@ecoventra.com" className="text-gray-300 text-sm hover:text-emerald-400 transition-colors">
                    info@ecoventra.com
                  </a>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-whatsapp-line text-white text-sm"></i>
                </div>
                <div>
                  <a 
                    href="https://api.whatsapp.com/send?phone=905326230183&text=Merhaba, sürdürülebilirlik danışmanlığı hizmetleriniz hakkında bilgi almak istiyorum." 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-300 text-sm hover:text-emerald-400 transition-colors"
                  >
                    WhatsApp ile İletişim
                  </a>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-emerald-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-global-line text-white text-sm"></i>
                </div>
                <div>
                  <a href="https://www.ecoventra.com" className="text-gray-300 text-sm hover:text-emerald-400 transition-colors">
                    www.ecoventra.com
                  </a>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-line text-white text-sm"></i>
                </div>
                <div>
                  <a 
                    href="https://calendly.com/ecoventra" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-300 text-sm hover:text-emerald-400 transition-colors"
                  >
                    Online Randevu Al
                  </a>
                </div>
              </div>
            </div>

            {/* Location */}
            <div>
              <h4 className="text-white font-medium mb-3 text-sm">Ofisimiz</h4>
              <div className="text-gray-400 text-xs flex items-start">
                <i className="ri-map-pin-line text-emerald-400 mr-2 text-xs mt-1 flex-shrink-0"></i>
                <div>
                  <div className="font-medium">İstanbul (Merkez)</div>
                  <div className="mt-1 text-xs leading-relaxed">
                    Büyükdere Cad. No: 185<br />
                    Kanyon Ofis Binası Kat: 9<br />
                    34394 Levent/İstanbul
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter Subscription */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="max-w-md mx-auto text-center">
            <h3 className="text-white font-semibold mb-4">E-Bülten Aboneliği</h3>
            <p className="text-gray-400 text-sm mb-4">
              Sürdürülebilirlik alanındaki son gelişmeleri ve haberlerimizi kaçırmayın
            </p>
            <form className="flex gap-2">
              <input
                type="email"
                placeholder="E-posta adresiniz"
                className="flex-1 px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 text-sm"
                required
              />
              <button
                type="submit"
                className="px-6 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors text-sm font-medium whitespace-nowrap"
              >
                Abone Ol
              </button>
            </form>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2025 ECOVENTRA. Tüm hakları saklıdır.
            </p>
            <div className="flex flex-wrap justify-center md:justify-end space-x-6 text-xs">
              <Link to="/iletisim" className="text-gray-400 hover:text-white transition-colors">Gizlilik Politikası</Link>
              <Link to="/iletisim" className="text-gray-400 hover:text-white transition-colors">Kullanım Şartları</Link>
              <Link to="/iletisim" className="text-gray-400 hover:text-white transition-colors">Çerez Politikası</Link>
              <Link to="/iletisim" className="text-gray-400 hover:text-white transition-colors">KVKK</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
